import { getPermissions } from '@app/api/account';
import { setAuthorizationToken } from '@app/api/api';
import { Configuration, PublicClientApplication, RedirectRequest } from '@azure/msal-browser';
import { notification } from '@digital/ui';

const msalConfig: Configuration = {
  auth: {
    clientId: '5f8db391-565c-4a65-8719-7829453ffe4b',
    authority: 'https://login.microsoftonline.com/f47270a0-d3c7-4087-9a4c-b4d829d0b243',
    redirectUri: window.location.origin + '/auth/redirect',
    knownAuthorities: ['login.microsoftonline.com'],
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
};

export const loginRequest: RedirectRequest = {
  scopes: ['api://f67c02dc-7e1f-4472-b084-9456524a4f40/access_as_user'],
};

import { useActions } from '@digital/ui/lib/store';
export const msalInstance = new PublicClientApplication(msalConfig);

export async function initMsal() {
  try {
    await msalInstance.initialize();
    const response: any = await msalInstance.handleRedirectPromise();

    if (!response) return;
    if (response && !response.account) return;
    console.log('[SSO] Login concluído', response.account.username);

    msalInstance.setActiveAccount(response.account);

    const scopes = ['api://f67c02dc-7e1f-4472-b084-9456524a4f40/access_as_user'];

    const tokenResponse = await msalInstance.acquireTokenSilent({
      account: response.account,
      scopes,
    });

    if (!tokenResponse || !tokenResponse.accessToken || !tokenResponse.expiresOn) {
      return;
    }

    const accessToken = tokenResponse.accessToken;

    localStorage.setItem('isAuthenticated', 'true');
    localStorage.setItem('isMRN', 'true');
    localStorage.setItem('expiration', String(Math.floor(tokenResponse.expiresOn!.getTime() / 1000)));
    localStorage.idtoken = accessToken;

    console.log('[SSO] Chamando getPermissions (merge do token local)...');

    setAuthorizationToken(accessToken);
    const permissionsResponse: any = await getPermissions();
    const permissions = permissionsResponse.permissoes;
    const idtoken = permissionsResponse.access_token;
    const expiration = permissionsResponse.expires_in;

    console.log('[SSO] Chamando getPermissions (merge do token local 2)...');

    console.log('[SSO] Chamando getPermissions (merge do token local 3)...');
    console.log(permissions);
    if (permissions.length === 1) {
      notification.error('Você não possui acesso ao sistema.');
      localStorage.removeItem('isAuthenticated');
      localStorage.removeItem('idtoken');
      localStorage.removeItem('expiration');
      localStorage.removeItem('userName');
      localStorage.removeItem('userLogadoId');
      localStorage.removeItem('isMRN');
      localStorage.removeItem('codigoUsuario');
      return;
    }

    localStorage.setItem('idtoken', idtoken);
    localStorage.setItem('expiration', expiration);
    localStorage.setItem('userLogadoId', permissionsResponse.userLogadoId);
    localStorage.setItem('codigoUsuario', permissionsResponse.codigoUsuario);

    const loadPermissions = useActions((state: any) => state.permission.loadPermissions);
    
    loadPermissions(permissions);
  } catch (e) {
    console.error('[SSO] erro MSAL', e);
  } finally {
  }
}
